export default __webpack_public_path__ + "static/media/ellipsisHorizontal.531974c1.svg";